var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PemsaPro"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4074 19.9998C28.4074 24.3432 24.8864 27.8642 20.543 27.8642C16.1996 27.8642 12.6786 24.3432 12.6786 19.9998C12.6786 15.6564 16.1996 12.1354 20.543 12.1354C24.8864 12.1354 28.4074 15.6564 28.4074 19.9998Z",
    fill: "var(--fill-0, #FF0000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9159 22.9829C34.9159 29.5729 29.5737 34.9151 22.9837 34.9151C16.3937 34.9151 11.0515 29.5729 11.0515 22.9829C11.0515 16.3929 16.3937 11.0507 22.9837 11.0507C29.5737 11.0507 34.9159 16.3929 34.9159 22.9829Z",
    fill: "var(--fill-0, #FF0000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0007 19.9998C36.0007 28.8364 28.8372 35.9998 20.0007 35.9998C11.1641 35.9998 4.00065 28.8364 4.00065 19.9998C4.00065 11.1633 11.1641 3.99984 20.0007 3.99984C28.8372 3.99984 36.0007 11.1633 36.0007 19.9998Z",
    fill: "var(--fill-0, #FF0000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8191 28.949C8.39348 27.0566 5.29057 22.6476 5.29057 17.5105C5.29057 10.6478 10.828 5.08458 17.6588 5.08458C22.875 5.08458 27.3371 8.32873 29.155 12.9183M28.4074 19.9998C28.4074 24.3432 24.8864 27.8642 20.543 27.8642C16.1996 27.8642 12.6786 24.3432 12.6786 19.9998C12.6786 15.6564 16.1996 12.1354 20.543 12.1354C24.8864 12.1354 28.4074 15.6564 28.4074 19.9998ZM34.9159 22.9829C34.9159 29.5729 29.5737 34.9151 22.9837 34.9151C16.3937 34.9151 11.0515 29.5729 11.0515 22.9829C11.0515 16.3929 16.3937 11.0507 22.9837 11.0507C29.5737 11.0507 34.9159 16.3929 34.9159 22.9829ZM36.0007 19.9998C36.0007 28.8364 28.8372 35.9998 20.0007 35.9998C11.1641 35.9998 4.00065 28.8364 4.00065 19.9998C4.00065 11.1633 11.1641 3.99984 20.0007 3.99984C28.8372 3.99984 36.0007 11.1633 36.0007 19.9998Z",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 1.66667
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.2e729aff1a78b557a66daad349fd3ff1.svg";
export { ForwardRef as ReactComponent };